import React from 'react';

const About = () => (
  <div className="container about">
    <p>
      Learn different food recipes via this website
    </p>
    <p>
      All data in these website come from The MealDb api
    </p>
  </div>
);

export default About;
